import 'angular';

import { AmsRewardsCsvCtrl }      from './ams-rewards.csv';
import { AmsRewardsStates }       from './ams-rewards.states.ajs';
import { AmsRewardsSettingsCtrl } from './ams-rewards.settings';

angular.module('workshop.amsRewards', [])
  .config(AmsRewardsStates)
  .controller('AmsRewardsCsvCtrl', AmsRewardsCsvCtrl)
  .controller('AmsRewardsSettingsCtrl', AmsRewardsSettingsCtrl);
